<template>
  <div class="page-container" style="text-align: center;">
    <div class="circle"></div>
    <div class="line1"></div>
    <div class="line2"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      count: 0,
      percent: "",
    };
  },
  mounted: function () {
    this.preload();
  },
  methods: {
    preload: function () {
      let imgs = [
        "static/home_center.png",
        "static/error_center.png",
        "static/hint_center.png",
        "static/error_center_en.png",
        "static/success_center.png",
        "static/success_center_en.png",
        "static/uivs_center.png",
        "static/uivs_center_en.png",
        "static/aboutimg02.jpg",
        "static/aboutimg02e.jpg"
      ];

      for (let img of imgs) {
        let image = new Image();
        image.src = img;
        image.onload = () => {
          this.count++;
          // 计算图片加载的百分数，绑定到percent变量
          let percentNum = Math.floor((this.count / 10) * 100);
          this.percent = `${percentNum}%`;
        };
      }
    },
  },

  watch: {
    count: function (val) {
      if (val === 10) {
        // 图片加载完成后跳转页面
        this.$router.replace({path: '/home'})
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;

}
.circle{
    display:inline-block;
    border-radius:9rem; /* 圆形边缘弧度 */
    width:18rem; /* 宽度 */
    height:18rem; /* 高度 */
    margin-top: 15%;
    background-image: linear-gradient(
    to right,
    #eeeeee 8%,
    #dddddd 18%,
    #eeeeee 33%
  );
  animation-duration: 4s;
  animation-iteration-count: infinite;
  animation-name: loading;
  animation-timing-function: linear;
  transition: 0.3s;
}
@keyframes loading {
  0% {
    background-position: -400px 0;
  }

  100% {
    background-position: 400px 0;
  }
}

.line1 {
  background-color: #fff;
  height: 25px;
  position: absolute;
  left: 27.5%;
  width: 45%;
  top: 70%;
  border-radius:10px;
   background-image: linear-gradient(
    to right,
    #eeeeee 8%,
    #dddddd 18%,
    #eeeeee 28%
  );
  animation-duration: 5s;
  animation-iteration-count: infinite;
  animation-name: loading;
  animation-timing-function: linear;
  transition: 0.3s;
}
.line2 {
background-color: #fff;
  height: 20px;
  position: absolute;
  left: 35%;
  width: 30%;
  top: 75%;
  border-radius:8px;
   background-image: linear-gradient(
    to right,
    #eeeeee 8%,
    #dddddd 18%,
    #eeeeee 33%
  );
  animation-duration: 7s;
  animation-iteration-count: infinite;
  animation-name: loading;
  animation-timing-function: linear;
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/pages/load/loading.vue